/* eslint-disable no-undef  */
import { useEffect } from 'react';
import { useStore } from '../../useStore';

export const useMapListeners = (map?: google.maps.Map): void => {
  const { setMapStepValues } = useStore();

  useEffect(() => {
    if (!map) return () => {};

    const centerListener = map.addListener('center_changed', () => {
      const latLng = map.getCenter();
      if (!latLng) return;
      setMapStepValues({ lat: latLng.lat(), lng: latLng.lng() });
    });

    return () => {
      window.google.maps.event.removeListener(centerListener);
    };
  }, [map, setMapStepValues]);
};
